module.exports = __webpack_public_path__ + "media/Components/fonts/Audiowide-d9088cb625e0abd3829c6f011870c150.ttf";